import { isValidIdentifier as a, quoteStringLiteral as y, quoteIdentifier as p, quoteQualifiedName as w } from "./db/identifiers.js";
import { g as A, b as i, r as m, s as Q } from "./instance-B0lHmJzq.js";
import { runQuery as c, runQueries as E } from "./db/query.js";
var S = /* @__PURE__ */ ((r) => (r.PARQUET = "parquet", r.DUCKDB = "duckdb", r))(S || {});
async function u(r) {
  if (Array.isArray(r)) {
    const n = await E(
      r.map((t) => t.sqlQuery),
      r.map((t) => t.nameMap)
    );
    for (let t = 0; t < n.length; t++)
      r[t]?.transform && (n[t] = r[t].transform(n[t]));
    return n;
  }
  const e = await c(r.sqlQuery, r.nameMap);
  return r?.transform ? r?.transform(e) : e;
}
const k = async ({
  url: r,
  databaseName: e,
  type: n,
  tableName: t,
  registerWithFileBuffer: o
}) => {
  if (!r)
    return {
      error: "URL is required",
      success: !1
    };
  if (!a(e))
    return {
      error: `Invalid database name: ${e}`,
      success: !1
    };
  if (n === "parquet" && !a(t))
    return {
      error: `Invalid table name: ${t}`,
      success: !1
    };
  if (A(e))
    return {
      success: !0
    };
  const f = n || "duckdb";
  if (o)
    try {
      const s = await fetch(r);
      if (!s.ok)
        return {
          error: `Network response for getting DuckDB binary from '${r}' was not ok. Status: ${s.status}`,
          success: !1
        };
      await i().registerFileBuffer(
        e,
        new Uint8Array(await s.arrayBuffer())
      );
    } catch (s) {
      return m(e), {
        error: `Download error: ${s}`,
        success: !1
      };
    }
  try {
    const s = i();
    switch (f) {
      case "parquet":
        await c(
          `CREATE SCHEMA IF NOT EXISTS ${p(e, "schema")};`
        ), await c(
          `CREATE TABLE ${w([e, t], "table")} AS SELECT * FROM read_parquet(${y(r)});`
        );
        break;
      case "duckdb":
        await c(
          `ATTACH DATABASE ${y(
            o ? e : r
          )} AS ${p(e, "database")} (READ_ONLY);`
        );
        break;
      default:
        return {
          error: `Invalid connection type: ${f}`,
          success: !1
        };
    }
    return Q(e, r, ""), s.markAttached(
      e,
      o ? e : null
    ), {
      success: !0
    };
  } catch (s) {
    if (o)
      try {
        await i().dropFileBuffer(e);
      } catch {
      }
    return m(e), {
      error: s?.message || "Something went wrong",
      success: !1
    };
  }
};
function l(r, e) {
  return {
    ...r,
    transform: e
  };
}
function D(r, e, n) {
  return n ? {
    sqlQuery: r,
    transform: e || ((t) => t),
    nameMap: n
  } : typeof e == "function" ? {
    sqlQuery: r,
    transform: e,
    nameMap: n
  } : {
    sqlQuery: r,
    transform: (t) => t,
    nameMap: e
  };
}
function T(r) {
  const e = Object.entries(r).map(([n, t]) => ({
    key: n,
    value: t
  }));
  return async () => {
    const n = await u(e.map(({ value: t }) => t.toSQL()));
    return Object.fromEntries(
      e.map(({ key: t }, o) => [t, n[o]])
    );
  };
}
function $(r) {
  const e = Object.entries(r).map(([n, t]) => ({
    key: n,
    value: t
  }));
  return async () => {
    const n = await u(e.map(({ value: t }) => t));
    return Object.fromEntries(
      e.map(({ key: t }, o) => [t, n[o]])
    );
  };
}
const C = {
  query: u,
  initializeFromUrl: k,
  makeQuery: D,
  transformQuery: l,
  combineQueries: $,
  combineSqlQueries: T
};
export {
  S as FileConnectionEnum,
  C as duckDB
};
